import globals from "@/utils/globals";
import cookie from "@/utils/cookie";

let config;

export const push = (...payload) => {
  window._paq = window._paq || [];

  window._paq.push(payload);
};

export const track = (...payload) => {
  push(...payload);
};

export const trackEvent = (...payload) => {
  const params = ["trackEvent"].concat(payload);
  push("deleteCustomVariable", 6, "page");
  track(...params);
};

export const trackBIEvent = (...payload) => {
  const biEvent = ["body-20190207-bi_event", "1-fire"];
  const biEventParams = ["trackEvent"].concat(biEvent);
  push("setCustomVariable", 6, "BIevent", JSON.stringify(payload), "page");
  track(...biEventParams);
};

export const trackPageView = (path) => {
  push("setCustomUrl", path);
  push("trackPageView");
};

export const updateReferrer = (previousPageUrl) => {
  push("setReferrerUrl", previousPageUrl);
};

export const createVueRouterPageViewTrackingHandler = (router) => {
  let isInitialVisit = true;
  return (to, from) => {
    // Note:  The Route objects to and from do not hold the real full path shown in the browser bar!
    // We have to prepend them with the router.options.base value - e.g. /business for the b2b pages.
    if (isInitialVisit) {
      // This router hook will be called also on the first load of the page.
      // In that case the "from" data is set to the current page.
      // For the first load we want to take the actual referrer value set by the browser and not
      // overwrite it with the current page url right away.
      isInitialVisit = false;
    } else {
      const previousPageUrl = `${ location.protocol }//${ location.host }${ router.options.base }${ from.fullPath }`;
      updateReferrer(previousPageUrl);
    }

    trackPageView(`${ router.options.base }${ to.fullPath }`);
  };
};

export const setAbTestsCustomVariable = (testCategories = {}) => {
  Object.keys(testCategories).map(testName => {
    var testWithCategory = `${testName}-${testCategories[testName]}`;

    if (globals.abtests.indexOf(testWithCategory) < 0) {
      globals.abtests.push(testWithCategory);
    }
  });

  if (globals.abtests.length > 0) {
    push("setCustomVariable", 1, "ABtests", globals.abtests, "page");
  }

  if (cookie("bk_c_n_ab")) {
    push("setCustomVariable", 5, "ABSessionId", cookie("bk_c_n_ab"), "page");
  }
};

const appendToTrackingUrl = () => {
  const isGuest = config.guest ? 1 : 0;
  const fingerprint = cookie("bk_c_n") || config.fingerprint;
  const segment = config.segment || globals.segment;

  push(function() {
    this.appendToTrackingUrl(`bk_u_g=${isGuest}&bk_c_n=${fingerprint}&bk_u_s=${segment}`);
  });
};

export const setConfig = (value) => {
  config = value;

  appendToTrackingUrl();
};
